/**
* Nom : LedCardTypeList.js
* Description : Ce fichier contient la définition de la page LedCardTypeList 
*               Cette page affiche les éléments pour gérer les types de carte Led
*               Le terme 'equipment' dans le code correspond à un produit client
* Date de création : 16 mars 2026
*/

/* CSS et assets */
import { AddIcon } from 'package_ui_ihm/dist'
import { RemoveIcon } from 'package_ui_ihm/dist'

/* Bibliothèques et composants */
import { CompanyBar } from 'package_ui_ihm/dist'
import { TabC } from 'package_ui_ihm/dist'
import { Container } from 'package_ui_ihm/dist'
import { Item } from 'package_ui_ihm/dist'
import { BackPage } from 'package_ui_ihm/dist'
import { GotoPage } from 'package_ui_ihm/dist'
import { SelectFormSide } from 'package_ui_ihm/dist'
import { FileFormSide } from 'package_ui_ihm/dist'
import { InputFormSide } from 'package_ui_ihm/dist'
import { ListFilter } from 'package_ui_ihm/dist'
import Divider from '@mui/material/Divider';

/* Hook */
import { useState, useEffect } from 'react'
import { useBlocker } from 'react-router-dom'
import { useAuth } from 'package_ui_ihm/dist'
import { useApi } from 'package_ui_ihm/dist'
import { useScreenWidth } from 'package_ui_ihm/dist'
import { function_display_file } from 'package_ui_ihm/dist'


/**
* LedCardTypeList : affiche la page qui contient les éléments pour gérer les types de carte LEDs
*                   un formulaire permet de filtrer en fonction du produit 
*                   pour afficher la liste de tout les types de carte LEDs associés
*                   un lien permet d'afficher un formulaire pour créer un nouveau type de carte LEDs
*                   un lien permet de revenir sur la page qui liste tous les sous-ensemble
*                   un lien permet d'aller sur la page qui liste tous types de PTUs
*                   un lien permet d'aller sur la page qui liste tous types de LEDs
*
* Type : page 
*
* Parametres : 
*  None
*/
function LedCardTypeList() {

    // Define useState hooks
    const [file, setFile] = useState(null);
    const [fileError, setFileError] = useState(false);
    const [referenceAT, setReferenceAT] = useState('');
    const [referenceATError, setReferenceATError] = useState(false);
    const [referenceManufacturer, setReferenceManufacturer] = useState('');
    const [referenceManufacturerError, setReferenceManufacturerError] = useState(false);
    const [width, setWidth] = useState(0);
    const [widthError, setWidthError] = useState(false);
    const [height, setHeight] = useState(0);
    const [heightError, setHeightError] = useState(false);
    const [manufacturer, setManufacturer] = useState('');
    const [manufacturerError, setManufacturerError] = useState(false);
    const [isDataLoading, setDataLoading] = useState(false)
    const [isCreation, setCreation] = useState(false)
    const [ledCardTypes, setLedCardTypes] = useState([])
    const [statusLedCardTypes, setStatusLedCardTypes] = useState(null)
    const [ledTypes, setLedTypes] = useState([])
    const [selectedLedType1, setSelectedLedType1] = useState(0);
    const [selectedLedType2, setSelectedLedType2] = useState(0);
    const [selectedLedType3, setSelectedLedType3] = useState(0);
    const [selectedLedType4, setSelectedLedType4] = useState(0);
    const [ledType1Error, setLedType1Error] = useState(false);
    const [ledType2Error, setLedType2Error] = useState(false);
    const [ledType3Error, setLedType3Error] = useState(false);
    const [ledType4Error, setLedType4Error] = useState(false);
    const [numberLedType1, setNumberLedType1] = useState(0);
    const [numberLedType2, setNumberLedType2] = useState(0);
    const [numberLedType3, setNumberLedType3] = useState(0);
    const [numberLedType4, setNumberLedType4] = useState(0);
    const [numberLedType1Error, setNumberLedType1Error] = useState(false);
    const [numberLedType2Error, setNumberLedType2Error] = useState(false);
    const [numberLedType3Error, setNumberLedType3Error] = useState(false);
    const [numberLedType4Error, setNumberLedType4Error] = useState(false);
    const [selectedManufacturer, setSelectedManufacturer] = useState(0);
    const [manufacturers, setManufacturers] = useState([]);
    const [filteredLedCardTypes, setFilteredLedCardTypes] = useState(ledCardTypes); 
    const [ledTypeNumber, setLedTypeNumber] = useState(1);


    // Define useContext hooks
    const { authStatus, authToken, currentUser} = useAuth();
    const { path } = useApi();


    // Define useBlocker hooks
    const shouldBlock = isCreation;
    const blocker = useBlocker(shouldBlock);


    // Define useScreenWidth hooks
    const screenWidth = useScreenWidth();


    // Define functions
    async function sendData(referenceAT, file, width, height, manufacturer, referenceManufacturer) {
        // Token
        const token = "Bearer " + authToken
        // Création du Form Data
        let form_data = new FormData();
        form_data.append("reference_AT", referenceAT);
        form_data.append("configuration_file", file, file.name);
        form_data.append("width", width);
        form_data.append("height", height);
        form_data.append("pcb_surface", width * height);
        form_data.append("manufacturer", manufacturer);
        form_data.append("reference_manufacturer", referenceManufacturer);
        // Create Led card Type
        const response = await fetch(path + "/api/eq-lcty/", 
            {
                method: 'POST',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    accept: 'application/json',
                    //'Content-Type': 'multipart/form-data',  cette ligne ne doit pas être utilisée avec FormData sinon erreur
                    Authorization: token,
                },
                body: form_data
            }
        );
        setStatusLedCardTypes(response["status"])
        let dataJson = await response.json()
        let led_card_type_id = dataJson.id
        if(response["status"] === 201){
            // Reset du formulaire
            setCreation(false)
            setReferenceAT('')
            setReferenceManufacturer('')
            setFile(null)
            setWidth(0)
            setHeight(0)
            setManufacturer('')
            setSelectedLedType1(0)
            setSelectedLedType2(0)
            setSelectedLedType3(0)
            setSelectedLedType4(0)
            setNumberLedType1(0)
            setNumberLedType2(0)
            setNumberLedType3(0)
            setNumberLedType4(0)
            // Creation des liens led card type et led type
            let selectedLedTypeInfos = [
                [selectedLedType1, numberLedType1], 
                [selectedLedType2, numberLedType2],
                [selectedLedType3, numberLedType3],
                [selectedLedType4, numberLedType4],
            ]
            for(let selectedLedTypeInfo of selectedLedTypeInfos)
            {
                if(selectedLedTypeInfo[0] !== 0)
                {
                    let form_data_link = new FormData();
                    form_data_link.append("led_card_type_id", led_card_type_id);
                    form_data_link.append("led_type_id", selectedLedTypeInfo[0]);
                    form_data_link.append("led_number", selectedLedTypeInfo[1]);
                    await fetch(path + "/api/eq-lllt/", 
                        {
                            method: 'POST',
                            credentials: 'include',
                            mode: 'cors',
                            headers: {
                                accept: 'application/json',
                                //'Content-Type': 'multipart/form-data',  cette ligne ne doit pas être utilisée avec FormData sinon erreur
                                Authorization: token,
                            },
                            body: form_data_link
                        }
                    );
                }
            }
            // Update ledCardType list
            retrieveLedCardTypes()
        }
    }

    const handleClick = (event) => {
        event.preventDefault();
        setCreation(true)
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        // Check of data for PTU type
        if(referenceAT === ''){
            setReferenceATError(true)
        }
        else
        {   
            setReferenceATError(false)
        }
        if(file === null || file === ''){
            setFileError(true)
        }
        else
        {   
            setFileError(false)
        }
        if(width <= 0){
            setWidthError(true)
        }
        else
        {   
            setWidthError(false)
        }
        if(height <= 0){
            setHeightError(true)
        }
        else
        {   
            setHeightError(false)
        }
        if(manufacturer === ''){
            setManufacturerError(true)
        }
        else
        {   
            setManufacturerError(false)
        }
        if(referenceManufacturer === ''){
            setReferenceManufacturerError(true)
        }
        else
        {   
            setReferenceManufacturerError(false)
        }
        if(selectedLedType1 === 0 || selectedLedType1 === '0'){
            setLedType1Error(true)
        }
        else
        {   
            setLedType1Error(false)
        }
        if(numberLedType1 <= 0){
            setNumberLedType1Error(true)
        }
        else
        {   
            setNumberLedType1Error(false)
        }
        if((selectedLedType2 === 0 || selectedLedType2 === '0') && (numberLedType2 > 0)){
            setLedType2Error(true)
        }
        else
        {   
            setLedType2Error(false)
        }
        if((selectedLedType2 > 0) && (numberLedType2 <= 0)){
            setNumberLedType2Error(true)
        }
        else
        {   
            setNumberLedType2Error(false)
        }
        if((selectedLedType3 === 0 || selectedLedType3 === '0') && (numberLedType3 > 0)){
            setLedType3Error(true)
        }
        else
        {   
            setLedType3Error(false)
        }
        if((selectedLedType3 > 0) && (numberLedType3 <= 0)){
            setNumberLedType3Error(true)
        }
        else
        {   
            setNumberLedType3Error(false)
        }
        if((selectedLedType4 === 0 || selectedLedType4 === '0') && (numberLedType4 > 0)){
            setLedType4Error(true)
        }
        else
        {   
            setLedType4Error(false)
        }
        if((selectedLedType4 > 0) && (numberLedType4 <= 0)){
            setNumberLedType4Error(true)
        }
        else
        {   
            setNumberLedType4Error(false)
        }
        if(referenceATError === false && fileError === false && widthError === false && heightError === false && manufacturerError === false && referenceManufacturerError === false && ledType1Error === false && numberLedType1Error === false){
            sendData(referenceAT, file, width, height, manufacturer, referenceManufacturer)
        }
    };

    const handleReset = (event) => {
        event.preventDefault();
        setCreation(false)
        setReferenceAT('')
        setFile(null)
        setWidth(0)
        setHeight(0)
        setManufacturer('')
        setReferenceManufacturer('')
        setSelectedLedType1(0)
        setSelectedLedType2(0)
        setSelectedLedType3(0)
        setSelectedLedType4(0)
        setNumberLedType1(0)
        setNumberLedType2(0)
        setNumberLedType3(0)
        setNumberLedType4(0)
        setReferenceATError(false)
        setFileError(false)
        setWidthError(false)
        setHeightError(false)
        setManufacturerError(false)
        setReferenceManufacturerError(false)
    };

    async function retrieveLedCardTypes() {
        // Token
        const token = "Bearer " + authToken
        // Retrieve ptu_types
        const resLedCardType = await fetch(path + "/api/eq-lcty/", 
            {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    accept: 'application/json',
                    Authorization: token,
                },
            }
        );
        const dataLedCardType = await resLedCardType.json();
        const led_card_type_list = dataLedCardType["results"]
        setLedCardTypes(led_card_type_list)
        // Listes des fabriquants
        const manufacturer_list = [...new Set(led_card_type_list.map((led_card_type) => (led_card_type.manufacturer)))]
        const manufacturer_dict = manufacturer_list.map((manufacturer_item, index) => ({"id": index + 1, "value": manufacturer_item}))
        setManufacturers(manufacturer_dict)
        // Dataloading
        setDataLoading(false)
    }

    async function retrieveLedTypes() {
        // Token
        const token = "Bearer " + authToken
        // Retrieve led_type
        const resLedType = await fetch(path + "/api/eq-lety/", 
            {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    accept: 'application/json',
                    Authorization: token,
                },
            }
        );
        const dataLedType = await resLedType.json();
        setLedTypes(dataLedType["results"])
    }

    function handleFile (event) {
        const file = event.target.files[0];
        setFile(file);
    };

    const displayDocument = (event, url) => {
        event.preventDefault();
        window.open(url, "_blank", "noopener,noreferrer")
    };

    function retrieve_param_object_from_id(list, id) {
        return (list.find((item) => (item['id'] === Number(id))))['value']
    }

    function updateFilteredLedCardTypes() {
        // Filter manufacturer
        if(Number(selectedManufacturer) > 0)
        {
            setFilteredLedCardTypes(ledCardTypes.filter((ledCardType) => ledCardType.manufacturer === retrieve_param_object_from_id(manufacturers, selectedManufacturer)))
        } 
        // No filter
        else
        {
            setFilteredLedCardTypes(ledCardTypes)
        }
    }

    const addLedType = (event) => {
        event.preventDefault();
        setLedTypeNumber(ledTypeNumber + 1)
    };

    const removeLedType = (event) => {
        event.preventDefault();
        setLedTypeNumber(ledTypeNumber - 1)
    };

    const filterReset = (event) => {
        event.preventDefault();
        setFilteredLedCardTypes(ledCardTypes)
        setSelectedManufacturer(0)
    }


    // Define useEffect hooks
    useEffect(() => {
        if(authStatus === 200)
        {
            setDataLoading(true)
            retrieveLedTypes()
            retrieveLedCardTypes()
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        updateFilteredLedCardTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ledCardTypes, selectedManufacturer])

    useEffect(() => {
        // Bloquer la fermeture d'onglet/rafraîchissement
        const handleBeforeUnload = (e) => {
        if (shouldBlock === true) {
            // Standard pour afficher une confirmation (les navigateurs modernes gèrent le message)
            e.preventDefault();
            e.returnValue = "";
            // Certains navigateurs nécessitent cette ligne pour afficher la confirmation
            return (e.returnValue = "Cette page vous demande de confirmer sa fermeture ; des données que vous avez saisies pourraient ne pas être enregistrées.");
        }
        }; 

        window.addEventListener("beforeunload", handleBeforeUnload);

        // Nettoyer l'écouteur quand le composant est démonté
        return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldBlock]);

    useEffect(() => {
        if (blocker.state === "blocked") {
            const confirmed = window.confirm(
                "Cette page vous demande de confirmer sa fermeture ; des données que vous avez saisies pourraient ne pas être enregistrées."
            );

            if (confirmed) {
                blocker.proceed();
            } else {
                blocker.reset();
            }
        }
    }, [blocker]);


    // Render component
    return (
        <div>
            <CompanyBar name_app="BOXIBRAIN"/>
            <TabC tabNumber={1}/>
            <div className={(screenWidth > 650) ? 'App' : 'App-ss'}>
                <Container>
                    {isDataLoading ? (
                        <p>Chargement des données</p>
                    ) : (
                        <div>
                            <h1>Types de cartes LEDs</h1>
                            {/*Lien de retour*/}
                            <div className={(screenWidth > 650) ? 'flex-row justify-center margin-bottom margin-top' : 'grid-1-1 justify-center margin-bottom margin-top'}>
                                <div className='link-border' style={(screenWidth > 650) ? { width: 240 } : null}>
                                    <BackPage path={'/equipments/subset'}>Retour aux sous-ensembles</BackPage>
                                </div>
                                <div className='link-border' style={(screenWidth > 650) ? { width: 240 } : null}>
                                    <GotoPage path={'/equipments/ptuType'}>Types de PTUs</GotoPage>
                                </div>
                                <div className='link-border' style={(screenWidth > 650) ? { width: 240 } : null}>
                                    <GotoPage path={'/equipments/ledCard'}>Cartes LEDs</GotoPage>
                                </div>
                                <div className='link-border' style={(screenWidth > 650) ? { width: 240 } : null}>
                                    <GotoPage path={'/equipments/ledType'}>Types de LEDs</GotoPage>
                                </div>
                            </div>
                            {/*Message d'erreur*/}
                            {(statusLedCardTypes !== null && statusLedCardTypes !== 201 && referenceATError === false) ? (
                                <p className='form-error'>Le type de carte LED existe déjà ou n'a pas pu être enregistré !</p>
                            ) : (
                                <p/>
                            )} 
                            {/*Liste et formulaire*/}
                            <div className={(screenWidth > 650) ? 'grid-1-3' : null}>
                                {/*New*/}
                                <div>
                                    {(currentUser["role_name"] !== "AT_RESEARCH") ? (
                                        <div className='flex-column'>
                                            <div className='link' onClick={handleClick}>
                                                <img src={AddIcon} alt='add_item_icon' className='link-img' />
                                                <div className='link-text'>Type de carte LED</div>
                                            </div>
                                            {(isCreation === true) ? (
                                                <div className='flex-rows'>
                                                    <h3>Nouveau type</h3>
                                                    <form onSubmit={handleSubmit} onReset={handleReset} className='flex-column'>
                                                        <div className='flex-column'>
                                                            <InputFormSide error={referenceATError} type="text" label="Référence Asclepios Tech" value={referenceAT} setValue={setReferenceAT}/>
                                                            <p className='italic-text-note zero-margin-bottom'>Référence = Nombre de LED en largeur x Nombre de LED en hauteur/liste (référence type LED)</p>
                                                            <p className='italic-text-note margin-bottom'>Exemple: 12x12/S3535-273_S3535-265</p>
                                                            <InputFormSide error={manufacturerError} type="text" label="Fabricant" value={manufacturer} setValue={setManufacturer}/>
                                                            <InputFormSide error={referenceManufacturerError} type="text" label="Référence fabricant" value={referenceManufacturer} setValue={setReferenceManufacturer}/>
                                                            <InputFormSide error={widthError} type="float" label="Largeur (en cm)" value={width} setValue={setWidth}/>
                                                            <InputFormSide error={heightError} type="float" label="Longueur (en cm)" value={height} setValue={setHeight}/>
                                                            <FileFormSide error={fileError} label="Ajouter un fichier" onChangeFunc={handleFile} currentValue={null}/>
                                                            <SelectFormSide error={ledType1Error} labelText={"Type de LED 1 (obligatoire)"} choices={ledTypes} choiceParam={'reference_AT'} selectedItem={selectedLedType1} setSelectedItem={setSelectedLedType1}/>
                                                            <InputFormSide error={numberLedType1Error} type="number" label="Nombre de LED" value={numberLedType1} setValue={setNumberLedType1}/>
                                                            {(ledTypeNumber >= 2) ? (
                                                                <div>
                                                                    <SelectFormSide error={ledType2Error} labelText={"Type de LED 2"} choices={ledTypes} choiceParam={'reference_AT'} selectedItem={selectedLedType2} setSelectedItem={setSelectedLedType2}/>
                                                                    <InputFormSide error={numberLedType2Error} type="number" label="Nombre de LED" value={numberLedType2} setValue={setNumberLedType2}/>
                                                                </div>
                                                            ) : (
                                                                null
                                                            )}
                                                            {(ledTypeNumber >= 3) ? (
                                                                <div>
                                                                    <SelectFormSide error={ledType3Error} labelText={"Type de LED 3"} choices={ledTypes} choiceParam={'reference_AT'} selectedItem={selectedLedType3} setSelectedItem={setSelectedLedType3}/>
                                                                    <InputFormSide error={numberLedType3Error} type="number" label="Nombre de LED" value={numberLedType3} setValue={setNumberLedType3}/>
                                                                </div>
                                                            ) : (
                                                                null
                                                            )}
                                                            {(ledTypeNumber === 4) ? (
                                                                <div>
                                                                    <SelectFormSide error={ledType4Error} labelText={"Type de LED 4"} choices={ledTypes} choiceParam={'reference_AT'} selectedItem={selectedLedType4} setSelectedItem={setSelectedLedType4}/>
                                                                    <InputFormSide error={numberLedType4Error} type="number" label="Nombre de LED" value={numberLedType4} setValue={setNumberLedType4}/>
                                                                </div>
                                                            ) : (
                                                                null
                                                            )}
                                                            <div className='grid-2-1-1-1 margin-bottom'>
                                                                <p className='item-text'>Type de LED</p>
                                                                {(ledTypeNumber < 4) ? (
                                                                    <img onClick={addLedType} src={AddIcon} alt='add_item_icon' className='link-img' />
                                                                ) : (
                                                                    null
                                                                )}
                                                                {(ledTypeNumber > 1) ? (
                                                                    <img onClick={removeLedType} src={RemoveIcon} alt='remove_item_icon' className='link-img' />
                                                                ) : (
                                                                    null
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className='flex-row form-center'>
                                                            <button type="reset" className='button'>Annuler</button>
                                                            <button type="submit" className='button'>Valider</button>
                                                        </div>
                                                    </form> 
                                                </div>
                                            ) : (
                                                <div></div>
                                            )}
                                        </div>
                                    ) : (
                                        null
                                    )}
                                    {/*Filtering*/}
                                    <h3>Filtres</h3>
                                    <ListFilter labelText='Fabricant' choices={manufacturers.sort((a, b) => (a.value > b.value)?1:-1)} choiceParam={'value'} selectedItem={selectedManufacturer} setSelectedItem={setSelectedManufacturer} subfilter={false}/>
                                    <div>
                                        <button onClick={filterReset} className='button-secondary clickable'>Sans filtres</button>
                                    </div>
                                </div>
                                {(screenWidth > 650) ? null : <Divider/>}
                                {/*Cartes LEDs type list*/}
                                <div className='scroll-list-rd'>
                                    {(filteredLedCardTypes && filteredLedCardTypes.length !== 0) ? (
                                        filteredLedCardTypes.sort((a, b) => (a.reference_AT > b.reference_AT)?1:-1).map((ledCardType) => (
                                            <Item key={ledCardType['id']} id={ledCardType['id']}>
                                                <h3 className='item-text'>Référence: {ledCardType['reference_AT']}</h3> 
                                                <div className={(screenWidth > 1100) ? 'grid-1-2' : null}>
                                                    <p className='item-text'>Fabricant : {ledCardType['manufacturer']}</p>
                                                    <p className='item-text'>Référence fabricant : {ledCardType['reference_manufacturer']}</p>
                                                </div>
                                                <div className={(screenWidth > 1100) ? 'grid-1-1-1' : (screenWidth > 650) ? 'grid-1-1' : null}>
                                                    <p className='item-text'>Largeur : {ledCardType['width']}cm</p> 
                                                    <p className='item-text'>Longueur : {ledCardType['height']}cm</p>
                                                    <p className='item-text'>Surface : {ledCardType['pcb_surface']}cm²</p>
                                                </div>
                                                <p className='item-text'>
                                                    Type et nombre de LEDs : 
                                                    {
                                                        (ledCardType['link_led_card_type_led_types'] && ledCardType['link_led_card_type_led_types'].length > 0) ? (
                                                            ledCardType['link_led_card_type_led_types'].map((link_led_card_type_led_type) => (" " + link_led_card_type_led_type['led_type']['reference_AT'] + " (" + link_led_card_type_led_type['led_number'] + "),"))
                                                        ) : (
                                                            null
                                                        )
                                                    }
                                                </p>
                                                <div className='item-text flex-row justify-start'>
                                                    Configuration : {function_display_file(ledCardType['configuration_file'].split("/").at(-1))}
                                                    {'  ( '}
                                                    <p className='link-doc clickable' onClick={(e) => displayDocument(e, ledCardType['configuration_file'])}><strong>Visualiser</strong></p>
                                                    {' )'}
                                                </div>
                                            </Item>
                                        ))
                                    ) : (
                                        <p>Aucun type de carte LED actuellement. Veuillez en créer un !</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </Container>
            </div>
        </div>
    );
}

export default LedCardTypeList;
